import { Button } from '@dixa/lib-shared-habla';
import { FunctionComponent } from 'react';

interface PropsT {
  text: string;
}

export const SatisfactionDisabledButton: FunctionComponent<PropsT> = ({
  text,
  ...otherProps
}) => (
  <Button {...otherProps} disabled>
    {text}
  </Button>
);
